import { render, staticRenderFns } from "./ExhibitorList.vue?vue&type=template&id=8b9c54a2&"
import script from "./ExhibitorList.vue?vue&type=script&lang=js&"
export * from "./ExhibitorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports